<div class="row adp-row" >
    <div class="col">{{item.instructorName}}</div>    
    <div class="col">{{item.adpEmployeeId}}</div>    
    <div class="col">{{item.jobCostCode}}</div>    
    <div class="col">{{item.sumInDollars | amount}}</div> 
    <div class="col">{{item.jobCostCodeDescription}}</div> 
    <div class="col">{{item.businessStructure}}</div> 
</div>